import React from "react";

import styles from "./index.module.css";

import withSection from "../withSection";
import GifAnimation from "../../atoms/GifAnimation";
import Gallery from "../../Gallery";

import { textAnimation } from "../../../constants";

const TeamItemText = ({ data, ...props }) => {
  return (
    <div className={styles.itemText} {...props}>
      <h3 className={styles.nameJp}>
        <GifAnimation gifSrc={textAnimation()} noHover>
          {data.name_jp}
        </GifAnimation>
      </h3>

      {data.name_en
        .toUpperCase()
        .split(" ")
        .map(name => {
          return (
            <h3 className={styles.nameEn} key={`${data.name_en}-${name}`}>
              <GifAnimation gifSrc={textAnimation()} noHover>
                {name}
              </GifAnimation>
            </h3>
          );
        })}

      <div className={styles.nameSpacer}></div>

      {data.title
        .replace(" (", "--(")
        .split("--")
        .map(title => {
          return (
            <h4 className={styles.title} key={`${data.title}-${title}`} dangerouslySetInnerHTML={{__html:title}}>
            </h4>
          );
        })}
    </div>
  );
};

const Teams = ({ data, ...props }) => {
  const results = (data && data.map(v => v.acf)) || {};
  return (
    <Gallery
      data={results}
      type="teams"
      containerClassName={styles.container}
      TextComponent={TeamItemText}
    />
  );
};

export default withSection(Teams);
